let swiperRegistered = false;

export async function ensureSwiperRegistered() {
  if (!swiperRegistered) {
    const { register } = await import('swiper/element/bundle');
    register();   // ? register swiper(it registers Swiper custom elements globally)
    swiperRegistered = true;
  }
}